import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import config from "../../config.json";
import http from "../../services/HttpService";
import auth from "../../services/authService";
import Joi from "joi-browser";
import UploadDocument from "../../comman/UploadDocument";
import { getTotalHours } from "../../services/appService";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import { uploadFileToBlob } from "../../services/blobUploadService";

const schema = {
  paidAmount: Joi.number().required().label("Amount to Pay ($)"),
  invoiceAmount: Joi.number().required().label("Invoice Amount"),
};

function CandidatePay(props) {
  const {
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
    payShowHide,
    handlePayShowHide,
    entityType
  } = props;

  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const validate = (currentData = data) => {
    const options = { abortEarly: false, allowUnknown: true };
    const result = Joi.validate(currentData, schema, options);
    if (!result.error) return null;
    const nextErrors = {};
    for (const item of result.error.details) {
      if (item.type === "any.required") nextErrors[item.path[0]] = item.message;
    }
    return Object.keys(nextErrors).length > 0 ? nextErrors : null;
  };

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    if (schema[name] === undefined) return null;
    const fieldSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, fieldSchema);
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const nextErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) nextErrors[input.name] = errorMessage;
    else delete nextErrors[input.name];

    const nextData = { ...data, [input.name]: input.value };

    if (input.name === "paidAmount") {
      const invoiceAmount = parseFloat(nextData.invoiceAmount) || 0;
      const enteredAmount = parseFloat(input.value) || 0;

      if (enteredAmount > invoiceAmount) {
        nextErrors[input.name] =
          "Amount to Pay cannot be greater than Invoice Amount!";
      } else if (enteredAmount === 0) {
        nextErrors[input.name] = "Amount to Pay must be a number";
      } else {
        delete nextErrors[input.name];
      }
    }

    setData(nextData);
    setErrors(nextErrors);
  };

  const doSubmit = async () => {

    if (Object.keys(errors).length > 0) {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    if (data.paidAmount === "") {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    const resultAlert = await getConfirmAlert(
      "Are you sure?",
      "You want to Add payment",
      "warning"
    );


    if (resultAlert.isConfirmed) {
      const user = auth.getCurrentUser();
      const { wfTask: workflowTask, handlePayShowHide } = props;
      const payload = { ...data };
      let docId = 0;

      if (documents.length > 0 && workflowTask) {
        const frmData = new FormData();
        frmData.append("message", payload.notes);
        frmData.append("workflowTask", JSON.stringify(workflowTask));
        frmData.append("userId", user.id);
        frmData.append(
          "files",
          JSON.stringify(
            documents.map((file) => ({
              name: file.name,
              type: file.type,
              size: file.size,
            }))
          )
        );
        const { data: result } = await http.post(config.ApplicantUploadDocument, frmData);
        docId = result?.uploadId;
        if (docId > 0) {
          payload.payDocId = docId;
          await http.post(config.UpdateInvoicePayment, payload);
          await Promise.all(
            documents.map((file, key) => {
              if (!file.file) return Promise.resolve();
              return uploadFileToBlob(
                file.file,
                result.sasUrls[key].uploadUrl,
                (progress) => {
                  console.log(`Upload progress for ${file.name}: ${progress}%`);
                }
              );
            })
          );
          handlePayShowHide("save");
          getAlert("Sent Successfully", "", "success");
        }
        return;
      }
      payload.payDocId = docId;
      await http.post(config.UpdateInvoicePayment, payload);
      handlePayShowHide("save");
      getAlert("Sent Successfully", "", "success");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    const formErrors = validate();
    setErrors(formErrors || {});
    if (formErrors) return;
    setIsProcessing(true);
    try {
      await doSubmit();
    } finally {
      setIsProcessing(false);
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      docs.push({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      });
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    if (index !== -1) {
      const nextDocuments = [...documents];
      nextDocuments.splice(index, 1);
      setDocuments(nextDocuments);
    }
  };

  const getPerdeimAmount = () => {
    const { getTotalDays, selectedObj, getFieldData, candidateObj } = props;
    if (!getTotalDays) return 0;
    const perfData = candidateObj.performerData;
    return (
      getTotalDays(selectedObj) *
      getFieldData(perfData, "candidateonboardingform", "Per_Diem_Rate")
    );
  };

  useEffect(() => {
    if (selectedObj !== undefined && selectedObj !== "") {
      const obj = selectedObj;
      const nextData = {};
      let candidateRate = 0;
      let invoType = invType;
      if (invType === "subcontractor") {
        if (entType === "C2C Basis" && candidateObj?.rates?.subcontractorRate) {
          candidateRate = candidateObj.rates.subcontractorRate;
        } else {
          if (candidateObj?.rates?.candidateRate) {
            candidateRate = candidateObj.rates.candidateRate;
          }
          invoType = "candidate";
        }
      }

      if (invType === "recruiter" && candidateObj?.rates?.recruiterRate) {
        candidateRate = candidateObj.rates.recruiterRate;
      }
      if (invType === "agency" && candidateObj?.rates?.agencyRate) {
        candidateRate = candidateObj.rates.agencyRate;
      }

      let fAmt = 0;
      if (invType === "subcontractor") {
        fAmt = parseFloat(getInvoiceAmount(obj));
      } else {
        fAmt = parseFloat(getTotalHours(obj?.workingHrs) * candidateRate);
      }
      const invItems = timeLogInvoices.filter((x) => x.timeLogId === obj.id);

      if (invItems.length > 0) {
        const selectedInvoice = invItems[0];
        if (selectedInvoice?.adjustmentMinues > 0) {
          fAmt -= selectedInvoice.adjustmentMinues;
        }
        if (selectedInvoice?.adjustmentPlus > 0) {
          fAmt += selectedInvoice.adjustmentPlus;
        }
        if (selectedInvoice?.adpDeduction > 0) {
          fAmt -= selectedInvoice.adpDeduction;
        }

        nextData.paymentMode = selectedInvoice.paymentMode;
        nextData.payNotes = selectedInvoice.payNotes;
        nextData.paidAmount = selectedInvoice.paidAmount;
        nextData.paymentDate = selectedInvoice.paymentDate?.split("T")[0];
      }

      nextData.id = obj.id;
      nextData.invoiceAmount = parseFloat(fAmt).toFixed(2);
      nextData.InvoiceType = invoType;
      nextData.paidAmount = parseFloat(fAmt).toFixed(2);
      setData(nextData);
      setErrors({});
    } else {
      setDocuments([]);
      setData({});
      setErrors({});
    }
  }, [
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
  ]);

  const dueAmount = useMemo(() => {
    if (
      data.paidAmount !== undefined &&
      data.paidAmount !== "" &&
      data.paidAmount !== null
    ) {
      return parseFloat(
        parseFloat(data.invoiceAmount || 0) - parseFloat(data.paidAmount || 0)
      ).toFixed(2);
    }
    return parseFloat(data.invoiceAmount || 0).toFixed(2);
  }, [data.invoiceAmount, data.paidAmount]);

  const perDiem = useMemo(() => {
    if (props.selectedObj !== "") return getPerdeimAmount();
    return undefined;
  }, [props.selectedObj, props.getTotalDays, props.candidateObj]);

  const renderInput = (name, label, type = "text", forcedValue) => (
    <Input
      type={type}
      name={name}
      value={forcedValue ?? data[name] ?? ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );


  return (
    <Modal show={payShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handlePayShowHide("close", "")}>
        <Modal.Title>
          {invType === "subcontractor" && "Payment"}
          {invType === "recruiter" && "Payment to Recruiter"}
          {invType === "agency" && "Payment Received Status"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          {entityType === "W2 Basis" && invType === "subcontractor" ? (
            <div className="col-md-6">{renderInput("invoiceAmount", "Net Pay ($)", "number")}</div>
          ) : (
            <div className="col-md-4">{renderInput("invoiceAmount", "Invoice Amount ($)", "number")}</div>
          )}
          {entityType !== "W2 Basis" || invType !== "subcontractor" ? (
            <>
              <div className="col-md-4">
                {renderInput(
                  "paidAmount",
                  `${invType === "agency"
                    ? "Payment Amount Received"
                    : "Amount to Pay ($)"
                  }`,
                  "number"
                )}
              </div>
              <div className="col-md-4">{renderInput("dueAmount", "Due Amount ($)", "number", dueAmount)}</div>
            </>
          ) : (
            <div className="col-md-6">{renderInput("perDiem", "Per Diem Amount ($)", "number", perDiem)}</div>
          )}
          <div className="col-md-2 form-group">
            <label htmlFor="" className="form-control-label">
              Payment Mode :
            </label>
          </div>
          <div className="col-md-2">
            <div className="custom-control custom-radio mb-3">
              <input
                name="paymentMode"
                className="custom-control-input"
                id="byCheck"
                type="radio"
                onChange={handleChange}
                value="Cheque"
                checked={data.paymentMode === "Cheque"}
              />
              <label className="custom-control-label" htmlFor="byCheck">
                By Cheque
              </label>
            </div>
          </div>
          <div className="col-md-8">
            <div className="custom-control custom-radio mb-3">
              <input
                name="paymentMode"
                className="custom-control-input"
                id="byAch"
                type="radio"
                onChange={handleChange}
                value="ACH"
                checked={data.paymentMode === "ACH"}
              />
              <label className="custom-control-label" htmlFor="byAch">
                By ACH
              </label>
            </div>
          </div>

          <div className="col-md-12 form-group">
            <label className="form-control">
              {data.paymentMode === "ACH" && "Payment made by ACH"}
              {data.paymentMode === "Cheque" && "Payment made by Cheque"}
            </label>
          </div>
          <div className="col-md-12 form-group">{renderInput("paymentDate", "Payment Date", "date")}</div>
          <div className="col-md-12">{renderTextArea("payNotes", "Notes")}</div>

          <div className="col-md-12">
            <UploadDocument
              documents={documents}
              onFileChange={onFileChange}
              handleFileRemove={handleFileRemove}
              btnLable={`${entityType === "W2 Basis" ? "Upload Pay Slip" : "Add"}`}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-outline-default"
          onClick={handleSubmit}
          disabled={isProcessing || !!validate()}
        >
          <i
            className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-paper-plane"}`}
            aria-hidden="true"
          ></i>{" "}
          Send
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CandidatePay;
